import React from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'
import { Container } from '@mui/material'

export const ItemEdit = (props) => {
  return (
    <>
      <Container className='mb-2'>
        <Edit title='Item Edit' {...props}>
          <SimpleForm>
            <TextInput disabled source='id' />
            <TextInput source='reservation' />
            <TextInput source='product' />
            <TextInput source='id_detail' />
          </SimpleForm>
        </Edit>
      </Container>
    </>
  )
}
